import { ReactNode } from 'react'

export const PhoneFrame = ({ children }: { children: ReactNode }) => (
	<div className="relative h-[560px] w-[276px] overflow-visible rounded-[theme(spacing.10)] border-8 border-black bg-white word-break-fix">
		{children}
	</div>
)
